import React, { memo } from 'react';
import { useQueryParams } from 'hooks';
import SortBy from 'components/common/SortBy';

export interface ISortFilterProps {
  disabled?: boolean;
  defaultOrder?: string;
  type?: 'events' | 'alphabetical' | 'pastEvents' | 'expiration';
}

const SortFilter: React.FC<React.PropsWithChildren<ISortFilterProps>> = (props) => {
  const { disabled, defaultOrder, type = 'events' } = props;
  const [queryParams, setQueryParams] = useQueryParams();
  const { ordering } = queryParams;

  const handleChangeOrder = (order: string, orderBy: string) => {
    setQueryParams({
      ...queryParams,
      ordering: order + orderBy,
    });
  };

  return (
    <SortBy
      disabled={disabled}
      sorting={ordering?.toString() || defaultOrder}
      type={type}
      onChange={handleChangeOrder}
    />
  );
};

export default memo(SortFilter);
